import ETHNICITY_OPTIONS from 'redux/constants/ethnicityOptions';
import LANGUAGE_OPTIONS from 'redux/constants/languageOptions';
import RACE_OPTIONS from 'redux/constants/raceOptions';

export function formatRaceEthnicitySummaryForDatabase(
  race: string,
  ethnicity: string
): string {
  const parts = [];
  if (race) parts.push(race);
  if (ethnicity) parts.push(`[${ethnicity}]`);
  return parts.join(' ');
}

export function formatRaceEthnicitySummaryForDisplay(summary: string): string {
  const { race, ethnicity } = getRaceEthnicity(summary);
  return race.concat(race && ethnicity ? ' / ' : '', ethnicity);
}

export function getRaceEthnicity(summary: string): {
  race: string;
  ethnicity: string;
} {
  if (!summary) return { race: '', ethnicity: '' };
  const [racePart, ethnicityPart] = summary.split('[');
  const race = racePart.trim();
  const ethnicity = (ethnicityPart || '').replace(']', '').trim();

  let formattedRace;
  let formattedEthnicity;

  if (!race) {
    formattedRace = '';
  } else {
    formattedRace = RACE_OPTIONS.includes(race) ? race : 'Other race';
  }

  if (!ethnicity) {
    formattedEthnicity = '';
  } else {
    formattedEthnicity = ETHNICITY_OPTIONS.includes(ethnicity)
      ? ethnicity
      : 'Not specified';
  }

  return { race: formattedRace, ethnicity: formattedEthnicity };
}

export function getLanguage(language: string): string {
  if (!language) return '';

  if (LANGUAGE_OPTIONS.includes(language)) {
    return language;
  }
  return 'Other language';
}
